import React from 'react';
import * as styles from './Button.module.scss';
import classNames from 'classnames';
import Tooltip from '@components/Tooltip';
import { Cancel, Reset } from './icons';

const icons = {
  cancel: Cancel,
  reset: Reset
};

export default function Button({
  children,
  className,
  href,
  showArrow: _showArrow,
  theme = 'primary',
  style = {},
  contentStyle = {},
  contentClassName,
  icon,
  iconClassName,
  color,
  fontSize,
  isClose,
  closeTooltipText = 'Close',
  disabled,
  ...restProps
}) {
  const showArrow = theme === 'primary' && _showArrow;
  const props = {
    ...restProps,
    style: { ...style, color, fontSize },
    disabled: !!disabled,
    // tabIndex: disabled ? 0 : -1,
    className: classNames('calculator-button', styles.button, {
      [className]: className && (!isClose || !closeTooltipText),
      [styles.arrow]: showArrow,
      [styles[theme]]: theme,
      [styles.close]: isClose,
      [styles.disabled]: disabled
    })
  };

  const Icon = icons[icon];

  const content = (
    <span
      className={classNames(styles.content, contentClassName)}
      style={contentStyle}
      tabIndex="-1"
    >
      {Icon && <Icon className={classNames(styles.icon, iconClassName)} />}
      {children}
    </span>
  );

  const component = (
    <>
      {href ? (
        <a
          href={href}
          {...props}
        >
          {content}
        </a>
      ) : (
        <button {...props}>{content}</button>
      )}
    </>
  );

  if (isClose && closeTooltipText) {
    return (
      <Tooltip
        text={closeTooltipText}
        className={className}
      >
        {component}
      </Tooltip>
    );
  }

  return component;
}
